// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6436":"bc4f06fb","9272":"c62a9c9b"}[chunkId] + ".chunk.css";
};